import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { VoucherPrintModel } from 'src/app/components/admin/booking/models/voucher-print.model';
import { BookingService } from 'src/app/components/admin/booking/services/booking.service';

@Component({
  selector: 'app-voucher-print',
  templateUrl: './voucher-print.component.html',
  styleUrls: ['./voucher-print.component.scss'],
})
export class VoucherPrintComponent implements OnInit, AfterViewInit { // TODO modal voucher

  a4Selected = false;
  mobileSelected = false;
  showValues = true;
  isLoading = false;
  modelSelectionError = false;
  errorMessage: string;
  statusInactive: boolean | null = null;

  constructor(
    public dialogRef: MatDialogRef<VoucherPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private bookingService: BookingService
  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.canDownloadVoucher();
    });
  }

  canDownloadVoucher(): void {
    const bookingId = this.data?.bookingId;

    this.bookingService.canDownloadVoucher(bookingId).subscribe({
      next: (value) => {
        setTimeout(() => {
          this.statusInactive = !value;
        }, 1500);
      },
      error: (err) => {
        setTimeout(() => {
          this.statusInactive = true;
          this.modelSelectionError = true;
          this.errorMessage = 'Não foi possível verificar o status do voucher. Tente novamente mais tarde.';
        }, 1500);
      }
    });
  }


  download() {
    this.modelSelectionError = false;
    const bookingId = this.data.bookingId;

    const templateType: number[] = [];
    if (this.a4Selected) templateType.push(2);
    if (this.mobileSelected) templateType.push(1);

    if (templateType.length === 0) {
      this.modelSelectionError = true;
      this.errorMessage = "Selecione pelo menos um modelo de voucher para continuar.";
      console.warn('Nenhum modelo de voucher selecionado.');
      return;
    }

    this.isLoading = true;
    const request: VoucherPrintModel = {
      templateType,
      showPaymentFields: this.showValues,
    };

    const isAgent = this.bookingService.isAgent();

    const download$ = isAgent
      ? this.bookingService.agentDownloadVoucher(request, bookingId)
      : this.bookingService.adminDownloadVoucher(request, bookingId);

    download$.subscribe({
      next: (result) => {
        if (!result || !result.data) {
          this.modelSelectionError = true;
          this.errorMessage = "Erro ao gerar o voucher, tente novamente mais tarde!";
          console.error('Resposta inválida da API:', result);
          this.isLoading = false;
          return;
        }

        const urls = Array.isArray(result.data) ? result.data : [result.data];
        urls.forEach(url => this.openInNewTab(url));

        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.isLoading = false;
        this.modelSelectionError = true;
        this.errorMessage = "Erro ao gerar o voucher, tente novamente mais tarde!";
        console.error('Erro ao gerar o voucher:', error);
      }
    });
  }

  private openInNewTab(fileUrl: string) {
    const anchor = document.createElement('a');
    anchor.href = fileUrl;
    anchor.target = '_blank';
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  onCheckboxChange() {
    if (this.a4Selected || this.mobileSelected) {
      this.modelSelectionError = false;
    }
  }

}
